import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";

//components
import ContentWrapper from "../../../containers/ContentWrapper";
import SelectShotConfirmTable from "./Table/SelectShotConfirmTable";

class ReviewShotShootStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shots: []
    };
  }

  handleSelectedShots = shot => {
    let state = this.state.shots;
    state.concat(shot);
    this.setState({ shot: state });
    console.log(this.state.shot);
  };

  submitShots = () => {
    this.props.submitShots();
  };

  render() {
    return (
      <ContentWrapper hasPadding>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button variant="contained" color="primary" disabled={false} onClick={this.props.goBackStep}>
            Back
          </Button>

          <Button variant="contained" color="primary" onClick={this.submitShots} disabled={this.props.submitting}>
            {this.props.submitting ? "Submitting" : "Submit"}
          </Button>
        </div>
        <Paper style={{ marginTop: 30 }}>
          <div style={{ padding: 24 }}>
            <Typography variant="subtitle2">Please review the shoots that will be added to the shoot.</Typography>
          </div>
          {this.props.submitting && <LinearProgress color="primary" style={{ height: 2 }} />}
          <Divider />
          <SelectShotConfirmTable shots={this.props.shots} type={this.props.type} />
        </Paper>
      </ContentWrapper>
    );
  }
}

export default ReviewShotShootStep;
